// used to construct the list of all pairs we consider by default in the frontend
import { ChainId, Token } from '@pancakeswap/sdk'
import { ChainTokenList } from './types'
import { MAIN_TOKEN2, BUSD, MAIN_TOKEN3, MAIN_TOKEN, MAIN_TOKEN4, USDT, WBNB } from './tokens'

export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  [ChainId.BSC]: [MAIN_TOKEN[ChainId.BSC], USDT[ChainId.BSC], BUSD[ChainId.BSC], WBNB[ChainId.BSC], MAIN_TOKEN2[ChainId.BSC], MAIN_TOKEN3[ChainId.BSC], MAIN_TOKEN4[ChainId.BSC]],
  [ChainId.BSC_TESTNET]: [MAIN_TOKEN[ChainId.BSC_TESTNET], USDT[ChainId.BSC_TESTNET], BUSD[ChainId.BSC_TESTNET], WBNB[ChainId.BSC_TESTNET], MAIN_TOKEN2[ChainId.BSC_TESTNET], MAIN_TOKEN3[ChainId.BSC_TESTNET], MAIN_TOKEN4[ChainId.BSC_TESTNET]],
  // [ChainId.ETH]: [MAIN_TOKEN[ChainId.ETH], USDT[ChainId.ETH], BUSD[ChainId.ETH], WBNB[ChainId.ETH], MAIN_TOKEN2[ChainId.ETH], MAIN_TOKEN3[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  // [ChainId.ARB]: [MAIN_TOKEN[ChainId.ARB], USDT[ChainId.ARB], BUSD[ChainId.ARB], WBNB[ChainId.ARB], MAIN_TOKEN2[ChainId.ARB], MAIN_TOKEN3[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  // [ChainId.BASE]: [MAIN_TOKEN[ChainId.BASE], USDT[ChainId.BASE], BUSD[ChainId.BASE], WBNB[ChainId.BASE], MAIN_TOKEN2[ChainId.BASE], MAIN_TOKEN3[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  // [ChainId.BASE_SEPOLIA]: [MAIN_TOKEN[ChainId.BASE_SEPOLIA], USDT[ChainId.BASE_SEPOLIA], BUSD[ChainId.BASE_SEPOLIA], WBNB[ChainId.BASE_SEPOLIA], MAIN_TOKEN2[ChainId.BASE_SEPOLIA], MAIN_TOKEN3[ChainId.BASE_SEPOLIA], MAIN_TOKEN4[ChainId.BASE_SEPOLIA]],
  // [ChainId.POLYGON]: [MAIN_TOKEN[ChainId.POLYGON], USDT[ChainId.POLYGON], BUSD[ChainId.POLYGON], WBNB[ChainId.POLYGON], MAIN_TOKEN2[ChainId.POLYGON], MAIN_TOKEN3[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  // [ChainId.DAN]: [MAIN_TOKEN[ChainId.DAN], USDT[ChainId.DAN], BUSD[ChainId.DAN], WBNB[ChainId.DAN], MAIN_TOKEN2[ChainId.DAN], MAIN_TOKEN3[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  // [ChainId.DANNY]: [MAIN_TOKEN[ChainId.DANNY], USDT[ChainId.DANNY], BUSD[ChainId.DANNY], WBNB[ChainId.DANNY], MAIN_TOKEN2[ChainId.DANNY], MAIN_TOKEN3[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {

  [ChainId.BSC]: [
    [MAIN_TOKEN[ChainId.BSC], WBNB[ChainId.BSC]],
    [MAIN_TOKEN[ChainId.BSC], USDT[ChainId.BSC]],
    [MAIN_TOKEN[ChainId.BSC], MAIN_TOKEN2[ChainId.BSC]],
    [MAIN_TOKEN[ChainId.BSC], MAIN_TOKEN3[ChainId.BSC]],
    [MAIN_TOKEN[ChainId.BSC], MAIN_TOKEN4[ChainId.BSC]],
    [MAIN_TOKEN2[ChainId.BSC], WBNB[ChainId.BSC]],
    [MAIN_TOKEN3[ChainId.BSC], WBNB[ChainId.BSC]],
    [MAIN_TOKEN3[ChainId.BSC], MAIN_TOKEN4[ChainId.BSC]],
  ],

  // [ChainId.ETH]: [
  //   [MAIN_TOKEN[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [MAIN_TOKEN[ChainId.ETH], USDT[ChainId.ETH]],
  //   [MAIN_TOKEN[ChainId.ETH], MAIN_TOKEN2[ChainId.ETH]],
  //   [MAIN_TOKEN[ChainId.ETH], MAIN_TOKEN3[ChainId.ETH]],
  //   [MAIN_TOKEN[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  //   [MAIN_TOKEN2[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [MAIN_TOKEN3[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [MAIN_TOKEN3[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  // ],
  // [ChainId.ARB]: [
  //   [MAIN_TOKEN[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [MAIN_TOKEN[ChainId.ARB], USDT[ChainId.ARB]],
  //   [MAIN_TOKEN[ChainId.ARB], MAIN_TOKEN2[ChainId.ARB]],
  //   [MAIN_TOKEN[ChainId.ARB], MAIN_TOKEN3[ChainId.ARB]],
  //   [MAIN_TOKEN[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  //   [MAIN_TOKEN2[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [MAIN_TOKEN3[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [MAIN_TOKEN3[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  // ],
  // [ChainId.BASE]: [
  //   [MAIN_TOKEN[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [MAIN_TOKEN[ChainId.BASE], USDT[ChainId.BASE]],
  //   [MAIN_TOKEN[ChainId.BASE], MAIN_TOKEN2[ChainId.BASE]],
  //   [MAIN_TOKEN[ChainId.BASE], MAIN_TOKEN3[ChainId.BASE]],
  //   [MAIN_TOKEN[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  //   [MAIN_TOKEN2[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [MAIN_TOKEN3[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [MAIN_TOKEN3[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  // ],
  // [ChainId.POLYGON]: [
  //   [MAIN_TOKEN[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [MAIN_TOKEN[ChainId.POLYGON], USDT[ChainId.POLYGON]],
  //   [MAIN_TOKEN[ChainId.POLYGON], MAIN_TOKEN2[ChainId.POLYGON]],
  //   [MAIN_TOKEN[ChainId.POLYGON], MAIN_TOKEN3[ChainId.POLYGON]],
  //   [MAIN_TOKEN[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  //   [MAIN_TOKEN2[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [MAIN_TOKEN3[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [MAIN_TOKEN3[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  // ],

  // [ChainId.DAN]: [
  //   [MAIN_TOKEN[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [MAIN_TOKEN[ChainId.DAN], USDT[ChainId.DAN]],
  //   [MAIN_TOKEN[ChainId.DAN], MAIN_TOKEN2[ChainId.DAN]],
  //   [MAIN_TOKEN[ChainId.DAN], MAIN_TOKEN3[ChainId.DAN]],
  //   [MAIN_TOKEN[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  //   [MAIN_TOKEN2[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [MAIN_TOKEN3[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [MAIN_TOKEN3[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  // ],
  // [ChainId.DANNY]: [
  //   [MAIN_TOKEN[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [MAIN_TOKEN[ChainId.DANNY], USDT[ChainId.DANNY]],
  //   [MAIN_TOKEN[ChainId.DANNY], MAIN_TOKEN2[ChainId.DANNY]],
  //   [MAIN_TOKEN[ChainId.DANNY], MAIN_TOKEN3[ChainId.DANNY]],
  //   [MAIN_TOKEN[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
  //   [MAIN_TOKEN2[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [MAIN_TOKEN3[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [MAIN_TOKEN3[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
  // ],
  

}

export const NetworkContextName = 'NETWORK'

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C',
]

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

export { default as farmsTestConfig } from './testnetfarms'
export { default as poolsConfig } from './pools'
export { default as ifosConfig } from './ifo'

export const FAST_INTERVAL = 10000
export const SLOW_INTERVAL = 60000

export const NOT_ON_SALE_SELLER = '0x0000000000000000000000000000000000000000'

export const FARM_AUCTION_HOSTING_IN_SECONDS = 604800

export const PREDICTION_TOOLTIP_DISMISS_KEY = 'prediction-switcher-dismiss-tooltip'

// Gelato uses this address to define a native currency in all chains
export const GELATO_NATIVE = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
export const GELATO_NATIVE_OTHER = '0x0000000000000000000000000000000000000000'

export const EXCHANGE_DOCS_URLS = 'https://t.me/PunkSwapDEX'
// export const EXCHANGE_DOCS_URLS = 'https://docs.punkswap.exchange/products/pancakeswap-exchange'
